import { FC } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

const StyledNav = styled.nav`
  font-family: "EB Garamond", serif;
  margin-bottom: 32px;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #7fa9e3ff;
  background: none;
  border: none;
  font-size: 20px;
  font-weight: 400;
  font-style: italic;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "EB Garamond", serif;

  &:hover {
    color: #5a9bf7;
    transform: translateX(-4px);
  }
`;

const BackText = styled.span`
  font-family: "EB Garamond", serif;
  font-style: italic;
`;

type ButtonProps = {
  to?: string; // Optional route to navigate to
  title: string;
  onClick?: () => void;
};

const BackButton: FC<ButtonProps> = ({ to, title, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      // If custom onClick is provided, use it
      onClick();
    } else if (to) {
      // If 'to' prop is provided, navigate to that route
      navigate(to);
    } else {
      // Default behavior: go back in history
      navigate(-1);
    }
  };

  return (
    <StyledNav>
      <BackLink onClick={handleClick}>
        <NavigateBeforeIcon />
        <BackText>{title}</BackText>
      </BackLink>
    </StyledNav>
  );
};

export default BackButton;
